import { getContext } from 'svelte';
import { MARKDOWN_STYLE_CONTEXT } from '../../constants/contexts';

export type MarkdownStyle = {
	size: 'small' | 'medium' | 'large';
	color: 'black' | 'gray';
};

// The size and colour the Markdown root was given, for renderers that style
// text themselves rather than through a size-specific paragraph component.
export const getMarkdownStyleContext = () =>
	getContext<MarkdownStyle | undefined>(MARKDOWN_STYLE_CONTEXT);
